module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};


//////////////////
// WEBPACK FOOTER
// ./en/components/x-form_git_metas.json
// module id = 857
// module chunks = 97